<template>
  <div>
    <div class="ms-text">
      {{ roadmap.name }}
    </div>
    <div class="ms-help" v-if="roadmap.parent_roadmap_id">
      {{
        roadmap.parent_roadmap_id
          ? `${roadmap.parent_roadmap_number}. ${roadmap.parent_roadmap_name}`
          : "Не привязан к этапу родительского договора"
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    roadmap: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>
